import React, { ReactElement, useEffect } from 'react';
import { useResetRecoilState, useSetRecoilState } from 'recoil';
import styled from 'styled-components';

import BottomTabLayouts from '@/layouts/bottomTab';
import TopMainWithBannerLayout from '@/layouts/topMainWithBanner';
import useOpenAppPrompt from '@/hooks/modal/useOpenAppPrompt';
import Banner from '@/containers/plan/index/Banner';
import TMGuaranteeMenu from '@/containers/plan/index/TMGuaranteeMenu';
import EtcGuaranteeMenu from '@/containers/plan/index/EtcGuaranteeMenu';
import Review from '@/containers/plan/index/Review';
import { SelectedIns, insuredPersonState } from '@/recoil/plan';
import { interestIdState } from '@/recoil/myPlan';
import { defaultUser } from '@/models/userInput';
import TaggedQuestions from '@/containers/plan/index/TaggedQuestions';
import FloatingMenu from '@/containers/plan/index/FloatingMenu';
import useEvent from '@/hooks/event/fall-2610/useEvent';
import Fall2610ModalBanner from '@/containers/event/npay-fall-261012/modal/Banner';

const HomePage = () => {
    const setSelIns = useSetRecoilState(SelectedIns);
    const setUserInfo = useSetRecoilState(insuredPersonState);
    const resetInterestId = useResetRecoilState(interestIdState);

    useOpenAppPrompt();

    useEffect(() => {
        setSelIns(0);
        setUserInfo(defaultUser);
        resetInterestId();
    }, [resetInterestId, setSelIns, setUserInfo]);

    const { mainBannerRender } = useEvent(true);

    const banner = [
        mainBannerRender ? 'event_fall-2610-l' : undefined,
        'main_consulting',
        'main_ina',
        'main_settlement',
        'main_pet',
    ];

    return (
        <Container>
            <Banner list={banner} />
            <TMGuaranteeMenu />
            <TaggedQuestions />
            <EtcGuaranteeMenu />
            <Review />
            <FloatingMenu />
            {mainBannerRender && <Fall2610ModalBanner />}
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    background-color: #f5f5f5;
`;

HomePage.getTopLayout = (page: ReactElement) => {
    return <TopMainWithBannerLayout>{page}</TopMainWithBannerLayout>;
};

HomePage.getBottomLayout = (page: ReactElement) => {
    return <BottomTabLayouts selectedItemKey="plan">{page}</BottomTabLayouts>;
};

export default HomePage;
